/** The store passes on the identity service's HTTP status as the error's resource id. */
const readStatus = (error: unknown): string | undefined => {
    const failure = error as { data?: { ErrorResourceId?: string }; error?: { data?: { ErrorResourceId?: string } } };
    return failure?.data?.ErrorResourceId ?? failure?.error?.data?.ErrorResourceId;
};

/** Whether a token refresh failed because the identity service could not answer, rather than because it refused the session. */
export const isRefreshUnanswered = (error: unknown): boolean => {
    const status = readStatus(error);
    return !status || status === '429' || /^5\d\d$/.test(status);
};
